import Breadcrumb, { BreadcrumbItem } from '@/components/Layout/Breadcrumb';
import InternalCredits from '@/components/Layout/InternalCredits';
import InternalTitle from '@/components/Layout/InternalTitle';
import { getCurrentHub } from '@sentry/nextjs';

export interface HeaderProps {
  breadcrumb: BreadcrumbItem[];
  titulo: string;
  publicacao: {
    autor: {
      nome: string;
      link: string;
    };
    editor?: {
      nome?: string;
      link?: string;
    };
    data: string;
    dataPublicacao: string;
    dataPublicacaoFormatada: string;
    dataAtualizacao?: string;
    dataAtualizacaoFormatada?: string;
  };
  isAdvertorial?: boolean;
  isSubDomain?: boolean;
  type?: string;
}

export default function Header({ breadcrumb, titulo, publicacao, isAdvertorial = false, isSubDomain = false, type = '' }: HeaderProps) {
  const currentSpan = getCurrentHub().getScope()?.getSpan();
  const headerSpan = currentSpan && currentSpan.startChild({ op: 'header' });

  const datas = {
    Publicacao: publicacao.dataPublicacao,
    PublicacaoFormatada: publicacao.dataPublicacaoFormatada,
    Atualizacao: publicacao.dataAtualizacao,
    AtualizacaoFormatada: publicacao.dataAtualizacaoFormatada,
  };

  return (
    <>
      <Breadcrumb breadcrumbList={breadcrumb} isSubDomain={isSubDomain} />
      <InternalTitle title={titulo} />
      <InternalCredits
        autoria={publicacao.autor.nome}
        urlAutoria={publicacao.autor.link}
        editoria={publicacao.editor && !isAdvertorial ? publicacao.editor.nome : null}
        urlEditoria={publicacao.editor && !isAdvertorial ? publicacao.editor.link : null}
        datas={datas}
        type={type}
      />
      {headerSpan && headerSpan.finish()}
    </>
  );
}
